import { useState, useEffect } from "react";

export type MicPermission = "granted" | "denied" | "prompt" | "unknown";

export function useMicPermission(): MicPermission {
  const [micPermission, setMicPermission] = useState<MicPermission>("unknown");

  useEffect(() => {
    if (typeof navigator === "undefined" || !navigator.permissions) return;

    let permissionStatus: PermissionStatus | null = null;

    navigator.permissions
      .query({ name: "microphone" as PermissionName })
      .then((status) => {
        permissionStatus = status;
        setMicPermission(status.state as MicPermission);
        status.onchange = () => {
          setMicPermission(status.state as MicPermission);
        };
      })
      .catch(() => {
        // Permissions API doesn't support microphone query in this browser
      });

    return () => {
      if (permissionStatus) {
        permissionStatus.onchange = null;
      }
    };
  }, []);

  return micPermission;
}
